import Mustache from 'mustache';
import { EmailTemplateData } from 'shared-types';

interface Params {
  emailTemplates: EmailTemplateData[];
  overridePlaceholderValues?: { [key: string]: string };
}

/**
 * Renders placeholders with values in email templates
 *
 * @param emailTemplates - list of email templates
 * @param overridePlaceholderValues - optional values for selected placeholders
 * @returns email templates with rendered placeholders
 */
const renderPlaceholdersInTemplates = ({
  emailTemplates,
  overridePlaceholderValues
}: Params) => {
  emailTemplates.forEach((template) => {
    Object.keys(overridePlaceholderValues || {}).forEach((key) => {
      if (!template.placeholders[key]) return;
      template.placeholders[key].value = overridePlaceholderValues?.[key];
    });

    const placeholders: { [key: string]: string } = {};

    Object.keys(template.placeholders).forEach((placeholderKey) => {
      const value =
        overridePlaceholderValues?.[placeholderKey] ||
        template.placeholders[placeholderKey].value;

      if (value) placeholders[placeholderKey] = value;
    });

    Object.keys(template.email).forEach((emailKey) => {
      const currentKey = emailKey as keyof EmailTemplateData['email'];

      if (currentKey === 'buttonEnabled') return;

      // convert all placeholders from double brackets to triple brackets
      // to properly render ex. urls
      const convertedString = (template.email[currentKey] as string)?.replace(
        /({{[^{}#^/]*}})(?!})/g,
        '{$1}'
      );

      try {
        template.email[currentKey] = Mustache.render(
          convertedString || '',
          placeholders
        );
      } catch (error) {
        if (error instanceof Error) {
          template.email[currentKey] = error.message;
        }
      }
    });
  });

  return emailTemplates;
};

export default renderPlaceholdersInTemplates;
